// src/utils/actionCodeSettings.js

const DEFAULT_ORIGIN = "https://www.zedipass.com";

const normalizeOrigin = (value, fallback) => {
  try {
    return new URL(value).origin;
  } catch (_) {
    return fallback;
  }
};

const isLocalHost = (hostname = "") =>
  hostname === "localhost" || hostname === "127.0.0.1" || hostname === "[::1]";

// Builds ActionCodeSettings so verification links point to a trusted origin.
// Stable links on your main domain are less likely to be flagged as suspicious.
export const getActionCodeSettings = () => {
  try {
    const configuredOrigin = normalizeOrigin(
      process.env.REACT_APP_EMAIL_VERIFICATION_ORIGIN ||
        process.env.REACT_APP_PUBLIC_URL ||
        DEFAULT_ORIGIN,
      DEFAULT_ORIGIN
    );

    const browserOrigin =
      typeof window !== "undefined" && window.location && window.location.origin
        ? window.location.origin
        : configuredOrigin;
    const browserHostname =
      typeof window !== "undefined" && window.location ? window.location.hostname : "";

    const origin = isLocalHost(browserHostname) ? configuredOrigin : browserOrigin;

    return {
      url: `${origin}/verify-email`,
      handleCodeInApp: false,
    };
  } catch (_) {
    return {
      url: `${DEFAULT_ORIGIN}/verify-email`,
      handleCodeInApp: false,
    };
  }
};

export default getActionCodeSettings;
